import styled from 'styled-components';

const Wrapper = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: flex-start;
	width: calc(80vw - 80px);
`;

const Page = styled.div`
  flex: 0 0 75%;
  box-shadow: 0px 4px 8px -3px rgba(0,29,79,0.2);
	position: relative;
	cursor: pointer;
	margin: 0 auto 2rem;

	@media (min-width: 850px) {
		flex: 0 0 calc(50% - 2rem);
		max-width: calc(50% - 2rem);
		margin: 0 1rem 2rem;
	}

	@media (min-width: 1250px) {
		flex: 0 0 calc(33.3333% - 2rem);
		max-width: calc(33.3333% - 2rem);
	}

	@media (min-width: 1600px) {
		flex: 0 0 calc(25% - 2rem);
		max-width: calc(25% - 2rem);
	}

	&:before {
		content: "";
		display: block;
		padding-bottom: 70.707%;
	}

	&:after {
		content: "";
		position: absolute;
		top: -6px;
		left: -6px;
		width: calc(100% + 8px);
		height: calc(100% + 8px);
		background-color: rgba(74,144,226, 0.02);
		border: 2px solid #4A90E2;
		border-radius: 4px;
		opacity: ${params => params.active === 1 ? 1 : 0};
		transition: opacity 0.1s ease-out;
		pointer-events: none;
	}
`;

const Description = styled.p`
	position: absolute;
	top: 16px;
	left: 50%;
	transform: translateX(-50%);

	font-size: 14px;
	text-align: center;

	padding: 5px 12px 6px;
	background-color: white;
	border-radius: 20px;
	box-shadow: 0px 0px 0px 1px rgba(0,0,0,0.1);
	opacity: 0.5;
	transition: opacity 0.2s ease-out;

	${Page}:hover & {
		opacity: 1;
	}
`;

export {
	Wrapper,
	Page,
	Description,
}
